import type { CmsSidebarSectionFragment } from "@workspace/casino_core/queries/CmsSidebarQuery";
import CmsPhrase from "@workspace/cms-phrases/src/phrase/CmsPhrase";
import LinkComponent from "@workspace/nextjs_utils/src/components/LinkComponent";
import type { FC } from "react";
import SidebarIcon from "./SidebarIcon";

type Item = NonNullable<CmsSidebarSectionFragment["items"]>[number];

type Props = {
  section: CmsSidebarSectionFragment;
  items: Item[];
  brandSlug: string;
};

const SidebarCollapsibleTooltip: FC<Props> = ({
  section,
  items,
  brandSlug,
}) => (
  <div>
    <p className="text-xs font-medium text-muted-foreground px-2 py-1.5">
      <CmsPhrase phrase={section.title} brandSlug={brandSlug} />
    </p>
    <ul className="flex flex-col gap-1">
      {items.map((item) => (
        <li key={item.id}>
          <LinkComponent
            href={item.href ?? ""}
            className="flex items-center gap-2 text-sm hover:text-sidebar-primary h-10 px-2"
          >
            <SidebarIcon icon={item.icon} hugeIcon={item.hugeIcon} size={20} />
            <CmsPhrase phrase={item.title} brandSlug={brandSlug} />
          </LinkComponent>
        </li>
      ))}
    </ul>
  </div>
);

export default SidebarCollapsibleTooltip;
